import { ModalMensajeComponent } from '../pages/General/modal-mensaje/modal-mensaje.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload';
import {faFilePdf} from '@fortawesome/free-solid-svg-icons/faFilePdf';
import {faBook} from '@fortawesome/free-solid-svg-icons/faBook';
import {faComment} from '@fortawesome/free-solid-svg-icons/faComment';
import {faLock} from '@fortawesome/free-solid-svg-icons/faLock';
import {faRss} from '@fortawesome/free-solid-svg-icons/faRss';

import { ErrorValidator } from '../models/personalizados/ErrorValidator';
import { Observable } from 'rxjs';
import * as moment from 'moment';

import { General } from '../models/General';
import { PDDatos } from '../models/PDDatos';
import { Catalogo } from '../models/Catalogo';
import { RequestNewInstanceGC } from '../models/BPM/RequestNewInstanceGC';
import { Fur } from '../models/Fur';
import { Router } from '@angular/router';
import { ModalMensaje } from '../models/ModalMensaje';
import { LoginMovil } from '../models/LoginMovil';
import { HttpHeaders } from '@angular/common/http';

//http://localhost:9091
export const ipServer = `/`; // PARA DESPLIEGUE- //https://desarrollo.oefa.gob.pe/
export const ipServerLaser = `/`; // PARA DESPLIEGUE

export const servicioToken = `${ipServer}siden-backend`;

export const HostSunat = servicioToken;

export const HostReniec = servicioToken; //
export const HostLaserFiche = `${ipServerLaser}siden-backend`; //
export const HostBPM = servicioToken; //

export const Host1 = servicioToken; //
export const HostInfobras = servicioToken; // calidad
export const HostBPM2 = servicioToken; //
export const HostSEACE = servicioToken; //

/// DESUSO
export const HostExpediente = `${ipServer}siden-backend`; //

export const HostPayaraInspira = ipServer;

export const constobraPublica = 1;
export const constcontrataciones = 21;
export const NumIdMacroProcCONT = 1;

export const PERSONA_MAESTRA = 2;
export const PERSONA_EXTERNA = 1;
export const iconError = faTimesCircle;
export const wcfClaveAUT = '#';
export const wcfClaveToken = '#';
export const wcfTipoCLAVE = '#';
export const wcfUsuarioAUT = '#';
export const codAccesoVerificarOk = 'C';
export const TipoNroExpdiente = 'DEN';
export const DscDenuncAnonimo = 'Anónimo';
export const rutaDocs = 'assets/docs/';
export const docInstrucciones = 'instrucciones.pdf';
export const DscNomDoc = 'Doc';
export const strMatTablePaginator = [5, 10, 1];
export const CodNuevoBand = '01';
export const CodRecibidoBand = '02';

export const NumIdTipoDocRUC = 3;

export const NumIdParamDiasVenc = 7;

export const NumIdTipCatTipoSelec = 12;
export const NumIdTipCatModalidad = 13;
export const NumIdTipCatTipoCompra = 14;
export const NumIdTipCatMoneda = 15;
export const NumIdTipCatTipRemitente = 26;
export const NumIdCatTROtros = 243;
export const NumIdCatTRCiudadano = 241;
export const NumIdCatTRPJ = 242;
export const StrDscToolTipText = '4000 caracteres es la cantidad máxima permitida';
export const IntCantTotalCar = 4000;

export const NumIdTipCatMotAccRea = 31;
export const NumIdTipCatMotEntidad = 32;
export const NumIdTipCatMotDesest = 33;

export const NumIdParamLeyMPD = 10;
export const NumIdParamMPDVerOfic = 11;
export const NumIdParamMPDVerFormato = 12;
export const NumIdParamTelefCGR = 35;
export const NumAnhoMinRegistro = 1998;

export const NumIdParamUsuDefCasilla = 32;
export const NumIdLinkRegCasilla = 33;

export class gvCanal {

  public static NumIdExp = 3;
  public static NumIdCorreo = 4;
  public static NumIdRedSocial = 6;
  public static NumIdReporte = 7;
  public static NumIdMesaPartes = 8;
  public static NumIdAppMovil = 9;
  public static NumIdRedFis = 10;
  public static NumIdEmpresarios = 11;
  public static NumIdMonitores = 12;
  public static NumIdAudiencias = 13;
  public static NumIdPostula = 14;
  public static NumIdBD = 15;
  public static NumIdServicios = 16;

  public static NumFormWeb = 1;

}

export const CodTipoExpDetREF = 'REF';
export const CodTipoExpDetDES = 'DES';

export const CodTipoFichaFUR = 'FUR';
export const CodSubTipoFichaFUR = 'FUR';
export const CodSubTipoFichaDOC = 'DOC';
export const CodSubTipoFichaCAR = 'CAR';
export const CodSubTipoFichaOFI = 'OFI';
export const CodTipoFichaEXP = 'EXP';
export const CodUnoGestDenuncias = 'L530';
export const CodUnoSubGerCMP = 'L334';

export const CodTipDocWORD = 'WORD';
export const CodTipDocPDF = 'PDF';

export const DscNombreFileOficioFUR = 'Oficio-Fur.pdf';
export const DscNombreFileOficioHEV = 'Oficio-Hev.pdf';

export const codModoPresPropio = 'PR';
export const codModoPresTraslado = 'TR';
export const dscModoPresPropio = 'Propio';
export const dscModoPresTraslado = 'Traslado de Denuncia';

export const CodTipoTramiteInstancia = 21;

export const NumIdCargoGestorCan = 3;
export const NumIdEstadoAsignado = 5;
export const NumIdEstadoAtendido = 9;
export const NumIdEstadoRegistrado = 4;
// export const NumIdEstadoEnEval = 86;

export const NumIdEstadoHePendiente = 13;
export const NumIdEstadoHeEvaluac = 14;
export const NumIdEstadoHeSuperv = 15;

export const NumIdEstadoBorrador = 22;

export const NumIdTipDenAnonimo = 5;
export const NumIdTipDenPersNat = 1;

export const NumIdTipDocPersJur = 3;

export const NumIdParamRutaArchPlan = 8;
export const NumIdParamRutaArchGen = 9;
export const NumIdCatTipoPD = 9;
export const NumIdCatTipoPDEntidad = 80;
export const NumIdCatTipoPDAgrupPJ = 81;
export const NumIdCatTipoPDCON = 82;
export const NumIdCatTipoPDRedSoc = 35;
export const NumIdCatTipoPDEmail = 36;
export const NumIdCatTipoPDMonit = 37;
export const NumIdCatTipoPDPrensa = 38;
export const NumIdCatTipoPDMP = 39;
export const NumIdCatTipoPDApp = 40;
export const NumIdCatTipoPDRFiscal = 41;
export const NumIdCatTipoPDEmpre = 42;
export const NumIdCatTipoPDAudien = 43;
export const NumIdCatTipoPDPostula = 44;
export const NumIdCatTipoPDBD = 45;
export const NumIdCatTipoPDServ = 46;
export const NumIdCatTipoPDExp = 47;

export const NumIdMedioNotifEmail = 1;

export const NumIdCatNombrPlantFW = 13;
export const NumIdCatNombrPlantFWEnt = 577;
export const NumIdCatNombrPlantFWAPJ = 629;
export const NumIdCatNombrPlantFWCON = 647;

export const NumIdCatTipoInstOci = 11;
export const NumIdCatTipoInstAdm = 12;

export const NumIdCatNombrPlantRSOC = 335;
export const NumIdCatNomPlantGenRSOC = 336;

export const NumIdCatNombrPlantExp = 389;
export const NumIdCatNomPlantGenExp = 390;

export const NumIdCatNombrPlantBD = 371;
export const NumIdCatNomPlantGenBD = 372;

export const NumIdCatNombrPlantServ = 373;
export const NumIdCatNomPlantGenServ = 374;

export const NumIdCatNombrPlantPostula = 369;
export const NumIdCatNomPlantGenPostula = 370;

export const NumIdCatNombrPlantAudien = 367;
export const NumIdCatNomPlantGenAudien = 368;

export const NumIdCatNomPlantPrensa = 355;
export const NumIdCatNomPlantGenPrensa = 356;

export const NumIdCatNomPlantEmpre = 365;
export const NumIdCatNomPlantGenEmpre = 366;

export const NumIdCatNomPlantApp = 359;
export const NumIdCatNomPlantGenApp = 360;

export const NumIdCatNomPlantRFiscal = 363;
export const NumIdCatNomPlantGenRFiscal = 364;

export const NumIdCatNomPlantMP = 357;
export const NumIdCatNomPlantGenMP = 358;

export const NumIdCatNombrPlantEmail = 345;
export const NumIdCatNomPlantGenEmail = 346;

export const NumIdCatNombrPlantMonit = 353;
export const NumIdCatNomPlantGenMonit = 354;
export const NumIdCargoOtrosCarg = 113;

export const NumIdInforRecib = 826;
export const NumIdTDEvidencia = 807;




export const NumIdCatDocGenFW = 14;
export const NumIdCatDocGenFWEnt = 578;
export const NumIdCatDocGenFWAPJ = 630;
export const NumIdCatDocGenFWCON = 648;
export const NumIdTipCatCampPlantFW = 10;
export const NumIdTipCatCampPlantOtros = 34;

export const NumIdTipCatCampPlantHE = 28;
export const NumIdTipCatCargTipoDest = 27;
export const NumIdTipCatDocSeguimiento = 29;
export const NumIdCatTipoDest1 = 1261;

export const NumIdTipCatDerivHe = 30;

export const NumIdRADenAuditInt = 6;
export const NumIdRAInfoOtraEnt = 7;
export const NumIdRADesestInfo = 8;
export const NumIdEstadoRegFUR = 4;

// export const NumIdParamLinkApp = 17;
// export const NumIdParamLinkDocEmail = 26;
export const NumIdTipoSistemaADM = 1;
export const NumIdTipoCatObjSeace = 108;


//
export const NumResultadoAnalisDenuncia = 1;

/*CUS07 */
export const NumIdEstadoHeEvaluacionSuperv = 86;
export const NumIdEstadoHeEvaluacionObservado = 87;
export const NumIdEstadoFudPendiente = 1;
/** */
export const CodDEM = 'DEM';
export const CodSNCCGR = 'CGR';
export const CodSNCOCI = 'OCI';

export const CodTipoInstEnt = 'ENT';

// export const CodTipoFichaFur = "FUR";
export const CodTipoFichaHe = 'HEV';

export const DscEtiquetaBtnVal = 'Validar';
export const DscEtiquetaBtnVal2 = 'Validando';

export const NumIdPrioridadMuyUrg = 9;
export const NumIdPrioridadUrg = 2;
export const NumIdPrioridadNormal = 1;

export const NumIdResAnPedInf = 4;
export const NumIdResAnInfComp = 5;

export const DscFuncInvPEDe = 'DESCONOZCO';

export const DscPathFwExt = 'FormularioWeb';
export const DscMensajeSpinner = 'Estamos procesando la información';
export const DscMensajeSpinner2 = 'Espere mientras generamos el archivo *pdf.  y el número de registro de su denuncia';
export const DscMensajeValFecha = 'Completa este campo';

export const IdCaptcha = 'input_ValCaptcha';



export const NumIdTipoDocDNI = 1;
export const NumIdTipoDocDesconocido = 2;

export const NumIdCargaTopeEvi = 16;

export const HtmlCabeceraEmail = '<html>\r\n' +
'<head>\r\n' +
'<style>\r\n' +
'div.b {\r\n' +
'  text-align: left;\r\n' +
'}\r\n' +
'\r\n' +
'div.c {\r\n' +
'  text-align: right;\r\n' +
'} \r\n' +
'\r\n' +
'div.d {\r\n' +
'  text-align: justify;\r\n' +
'}\r\n' +
'div.bar{\r\n' +
'	background-color: black;\r\n' +
'    color:white;\r\n' +
'    text-align: center;\r\n' +
'}\r\n' +
'div.p{\r\n' +
'	color:blue;\r\n' +
'    text-align: left;\r\n' +
'}\r\n' +
'</style>\r\n' +
'</head>\r\n' +
'<body>\r\n' +
'<div class="bar" >OEFA</div><br>\r\n' +
'<div class = "p">Estimado(a) ciudadano(a):</div>\r\n' +
'<div class="d">\r\n';

export const HtmlPieEmail = '\r\n' +
'<p><i><span style="font-family: Century Gothic, CenturyGothic;">Cordialmente.</span></i></p>\r\n' +
'<div class="c">\r\n' +
'<H2><i><span style="font-family: Century Gothic, CenturyGothic;">OEFA</span></i></H2>\r\n' +
'<div class="b">\r\n' +
'<p>Esta dirección de correo electrónico no puede recibir respuestas. Por favor, no responda este mensaje.</p></div>\r\n' +
'</body>\r\n' +
'</html>';

// Correo
export const correoEmisor = '#';
//

// Año
export const anioActualGlobal = 2020;
export const stringFechaMaxima = anioActualGlobal + '-12-31';

// codigo
export const codigoIncial = '000000000000';
//
// export const iconoMatAgregar = "note_add";
export const DscTituloPaginator = 'Registros por Página';
export const DscHoraDefault = ' 00:00:01';
export const listTypesUpload = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                'application/msword',
                                'application/pdf',
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                'application/vnd.ms-excel',
                                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                                'application/vnd.ms-powerpoint',
                                '.txt',
                                'image/png',
                                'image/jpeg',
                                'image/jpg',
                                'image/gif',
                                '.mp4',
                                '.avi',
                                '.mkv',
                                '.flv',
                                '.m4a',
                                '.mp3',
                                '.wav'
                              ];
export const listTypesUpload2 = ['rar',
                              'zip',
                              'xps',
                              'txt',
                              'Gz',
                              'mp4',
                              'avi',
                              'mkv',
                              'flv',
                              'm4a',
                              'mp3',
                              'wav'
                            ];




export class GlobalVars {
  // public static CodDep: string;
  public static CodUsuario: string;
  public static DscContrasenha: string;
  public static CodPersonal: string;
  public static DscNombreComplPers: string;
  public static CodPersSuperv: string;
  public static FlgSupervisor = false;
  public static CodPersSedeDpto: string;
  public static FlgGestor = false;
  public static FlgOtroUsuario = false;
  public static CodUNOPers: string;
  public static CodSNC: string;
  public static DscRutaArchivoPlant: string;
  public static DscRutaArchivoPlantGen: string;
  public static objetoFurAcceda: Fur;
  public static FlgNuevoFw = false;
  public static objetoRegExitoso: ModalMensaje;
  public static FlgRegExitoso = false;
  public static objOlvidoClave: LoginMovil;

}

export class ParametroVars {
  public static Param17 = '#'; // 17
  public static Param6 = '#'; // 6
  public static Param18 = '#'; // 18
  public static Param27 = '#'; // 27
  public static Param28 = '#'; // 27
  public static Param29 = '#'; // 27
  public static Param35 = '#'; // 27
  public static Param26 = '#'; // 27

}

export function iconPanelContraer(flgContraer: boolean) {
  return (flgContraer ? 'keyboard_arrow_left' : 'keyboard_arrow_down');

}

export function isNotEmpty(data: string) {

  if (typeof(data) === 'object') {
    if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
        return false;
    } else if (!data) {
        return false;
    }
    return true;
  } else if (typeof(data) === 'string') {
    if (!data.trim()) {
        return false;
    }
    return true;
  } else if (typeof(data) === 'undefined') {
    return false;
  } else {
    return true;
  }

}

export function isEmpty(data: string) {

  return !isNotEmpty(data);

}

export function getFlgOtrosCanal(numIdCanal: number) {

  return (numIdCanal == gvCanal.NumIdCorreo || numIdCanal == gvCanal.NumIdRedSocial
        || numIdCanal == gvCanal.NumIdReporte || numIdCanal == gvCanal.NumIdExp
        || numIdCanal == gvCanal.NumIdMesaPartes || numIdCanal == gvCanal.NumIdAppMovil
        || numIdCanal == gvCanal.NumIdRedFis || numIdCanal == gvCanal.NumIdEmpresarios
        || numIdCanal == gvCanal.NumIdMonitores || numIdCanal == gvCanal.NumIdAudiencias
        || numIdCanal == gvCanal.NumIdBD || numIdCanal == gvCanal.NumIdPostula || numIdCanal == gvCanal.NumIdServicios
        );

}

export function horaAMPM(fecha: Date) {

  let d = fecha;

  if (!d) {

    d =  new Date();

  } else {

    d = new Date(fecha.toString());

  }

  const amOrPm = (d.getHours() < 12) ? 'a.m.' : 'p.m.';
  let hour = (d.getHours() < 12) ? d.getHours() : d.getHours() - 12;

  if (hour == 0) {

    hour = 12;

  }

  let min = d.getMinutes().toString();

  min = (min.length == 1 ? '0' + min : min);

  return hour + ':' + min + ' ' + amOrPm;


}

export function funcFechaActualAMPM(fecha: string) {

    const d = new Date (fecha);

	   fecha = ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();

    const hh = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();
    let dd = 'a.m.';
    let h = hh;
    if (h >= 12) {
       h = hh - 12;
       dd = 'p.m.';
     }
    if (h == 0) {
       h = 12;
     }
    const min = m < 10 ? '0' + m : m;

    let replacement = h + ':' + min;

    replacement += ' ' + dd;
  	 return fecha + ' ' + replacement;
}

export function cookieGlobalVars(numCaso: number) {


  const strCampo1 = 'cod-usuario';
  const strCampo2 = 'dsc-contrasenha';
  const strCampo3 = 'cod-personal';
  const strCampo4 = 'cod-perssuperv';
  const strCampo5 = 'flg-supervisor';
  const strCampo6 = 'cod-perssededpto';
  const strCampo7 = 'flg-gestor';
  const strCampo8 = 'flg-otrousuario';
  const strCampo9 = 'dsc-nombrecomplpers';
  const strCampo10 = 'cod-unopers';
  const strCampo11 = 'cod-snc';
  const strCampo12 = 'ruta-file-plant';
  const strCampo13 = 'ruta-file-plant-gen';
  const strCampo14 = 'objeto-fur-acceda';
  const strCampo15 = 'flg-nuevo-fw';
  const strCampo16 = 'objeto-regexitoso';
  const strCampo17 = 'objeto-olvidoclave';
  let boolFlgNuevoFw = false;
  // var strCampo17 = "flg-regexitoso";

  switch (numCaso) {
    case 1:

     console.log('===========0CASO 1');

     window.localStorage.setItem(strCampo1, GlobalVars.CodUsuario);
     window.localStorage.setItem(strCampo2, GlobalVars.DscContrasenha);
     window.localStorage.setItem(strCampo3, GlobalVars.CodPersonal);
     window.localStorage.setItem(strCampo4, GlobalVars.CodPersSuperv);

      // console.log("===========0CASO 2");

     window.localStorage.setItem(strCampo5, GlobalVars.FlgSupervisor.toString());
     window.localStorage.setItem(strCampo6, GlobalVars.CodPersSedeDpto);
     window.localStorage.setItem(strCampo7, GlobalVars.FlgGestor.toString());

      // console.log("===========0CASO 3");

     window.localStorage.setItem(strCampo8, GlobalVars.FlgOtroUsuario.toString());


      // console.log("===========0CASO 4");
     window.localStorage.setItem(strCampo9, GlobalVars.DscNombreComplPers);
     window.localStorage.setItem(strCampo10, GlobalVars.CodUNOPers);
     window.localStorage.setItem(strCampo11, GlobalVars.CodSNC);
     window.localStorage.setItem(strCampo12, GlobalVars.DscRutaArchivoPlant);
     window.localStorage.setItem(strCampo13, GlobalVars.DscRutaArchivoPlantGen);



     break;

    case 2:


      GlobalVars.CodUsuario = window.localStorage.getItem(strCampo1);
      GlobalVars.DscContrasenha = window.localStorage.getItem(strCampo2);
      GlobalVars.CodPersonal = window.localStorage.getItem(strCampo3);
      GlobalVars.CodPersSuperv = window.localStorage.getItem(strCampo4);
      GlobalVars.FlgSupervisor = JSON.parse(window.localStorage.getItem(strCampo5));
      GlobalVars.CodPersSedeDpto = window.localStorage.getItem(strCampo6);
      GlobalVars.FlgGestor = JSON.parse(window.localStorage.getItem(strCampo7));
      GlobalVars.FlgOtroUsuario = JSON.parse(window.localStorage.getItem(strCampo8));
      GlobalVars.DscNombreComplPers = window.localStorage.getItem(strCampo9);
      GlobalVars.CodUNOPers = window.localStorage.getItem(strCampo10);
      GlobalVars.CodSNC = window.localStorage.getItem(strCampo11);
      GlobalVars.DscRutaArchivoPlant = window.localStorage.getItem(strCampo12);
      GlobalVars.DscRutaArchivoPlantGen = window.localStorage.getItem(strCampo13);

      break;

    case 3:

      boolFlgNuevoFw = GlobalVars.FlgNuevoFw;

      boolFlgNuevoFw = (boolFlgNuevoFw ? boolFlgNuevoFw : false);

      window.localStorage.setItem(strCampo14, JSON.stringify(GlobalVars.objetoFurAcceda));

      window.localStorage.setItem(strCampo15, boolFlgNuevoFw.toString());

      break;

    case 4:


      GlobalVars.objetoFurAcceda = JSON.parse(window.localStorage.getItem(strCampo14));

      GlobalVars.FlgNuevoFw = JSON.parse(window.localStorage.getItem(strCampo15));

      break;

    case 5:

      window.localStorage.setItem(strCampo16, JSON.stringify(GlobalVars.objetoRegExitoso));

      break;


    case 6:

      GlobalVars.objetoRegExitoso = JSON.parse(window.localStorage.getItem(strCampo16));

      break;

    case 7:

      window.localStorage.setItem(strCampo17, JSON.stringify(GlobalVars.objOlvidoClave));

      break;


    case 8:

      GlobalVars.objOlvidoClave = JSON.parse(window.localStorage.getItem(strCampo17));

      break;

    default:
      break;
  }



}



export function saveContent(fileContents, fileName, numCaso?) {

  switch (numCaso) {
    case 1:

      fileContents = 'data:application/pdf;base64,' + fileContents;

      break;

    default:
      break;
  }



  // console.log("====fileContents");
  // console.log(fileContents);

  const link = document.createElement('a');
  link.download = fileName;
    // link.href = 'data:application/octet-stream;base64,' + fileContents;
  link.href =  fileContents;
  link.click();
}

export function saveContent2(fileContents, fileName) {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = fileContents;
    link.click();
}

export function openModalMensaje(dscTitulo: string, dscMensaje: string, dialog: MatDialog, boolFlgHTML?: boolean, numCasoHeight?: number) {

    let strHeight = '';

    numCasoHeight = (numCasoHeight ? numCasoHeight : 1);

    switch (numCasoHeight) {
      case 1:

        strHeight = '37%';

        break;

      case 2:

        strHeight = '40%';

        break;

      default:
        break;
    }


    const dialogRef = dialog.open(ModalMensajeComponent, { width: '55%', height: strHeight, data: {titulo : dscTitulo, mensaje: dscMensaje, flgHtml: boolFlgHTML}});

    return dialogRef;
}

export function openModalMensajePrg(dscTitulo: string, dscMensaje: string, dialog: MatDialog, flgCaptcha?: boolean, numCasoHeight?: number, numCasoWidth?: number) {

  let strHeight = '';
  let strWidth = '';

  numCasoHeight = (numCasoHeight ? numCasoHeight : 1);
  numCasoWidth = (numCasoWidth ? numCasoWidth : 1);

  if (flgCaptcha == true) {

    numCasoHeight = 2;
    numCasoWidth = 2;
    dscTitulo = (dscTitulo.length == 0 ? 'Ingrese el Captcha' : dscTitulo);

  }


  switch (numCasoHeight) {
    case 1:

      strHeight = '35%';

      break;

    case 2:

      strHeight = '55%';

      break;

    default:
      break;
  }

  switch (numCasoWidth) {
    case 1:

      strWidth = '50%';

      break;

    case 2:

      strWidth = '60%';

      break;

    default:
      break;
  }


  const dialogRef = new Observable(observer => {

    dialog.open(ModalMensajeComponent, { width: strWidth, height: strHeight, data: {titulo : dscTitulo, mensaje: dscMensaje, flgRegresar: true, flgCaptcha}}).afterClosed().subscribe(result => {

      observer.next(result);

    });


  });

  return dialogRef;

}


export function ValidarEmail(dscEmail: string) {

    const emailRegex = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

    return emailRegex.test(dscEmail);
}

export function ConvertirFlag(flag: boolean) {


    return (flag) ? 'SI' : 'NO';
}
export function ConvertirFlagPre(flag: boolean) {


  return (flag) ? 'SI' : 'NO PRECISA';
}

export function getBooleanFlag(flag: string) {
  return (flag == 'SI') ? true : false;
}
export function  loadCaptcha01(url: String , val: string) {
  return url + '/validata/code/' + val;
}

export function uuid(len, radix) {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('') , uuid = [], i;
    radix = radix || chars.length;
    if (len) {
        // Compact form
        for (i = 0; i < len; i++) { uuid[i] = chars[0 | Math.random() * radix]; }
    } else {
        // rfc4122, version 4 form
        let r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');
}
export function GetDate() {

  const fecha = new Date();
  const dia = fecha.getDate();
  const diaString = ((dia < 10) ? ('0' + dia) :  dia) ;
  const mes = Number(fecha.getMonth()) + 1;
  const mesString = (mes < 10) ? ('0' + String(mes)) : String(mes);
  const fechaString = diaString + '/' + mesString + '/' +  fecha.getFullYear();

  return fechaString;
}

export function GetDateTime(numValor: number, numCaso: number) {
  const fecha = new Date();

  switch (numCaso) {
    case 1:

      fecha.setDate(fecha.getDate() + numValor);

      break;
    case 2:

      fecha.setDate(fecha.getDate() - numValor);

      break;

    default:
      break;
  }

  const dia = fecha.getDate();

  const diaString = ((dia < 10) ? ('0' + dia) :  dia) ;
  const mes = Number(fecha.getMonth()) + 1;

  const mesString = (mes < 10) ? ('0' + String(mes)) : String(mes);


  const fechaString = diaString + '/' + mesString + '/' +  fecha.getFullYear() + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();

  return fechaString;

}

export function GetAnho() {

  const fecha = new Date();

  return fecha.getFullYear();
}

export function GetMes() {

  const fecha = new Date();

  return fecha.getMonth() + 1;
}

export function GetDia() {

  const fecha = new Date();

  return fecha.getDate();
}

export function GetFecActualMaxCal() {

  return GetAnho() + '-' + ('0' + GetMes()).slice(-2) + '-' + ('0' + GetDia()).slice(-2);
}

export function GetDateHour() {

  const fecha = new Date();
  const dia = fecha.getDate();
  // let fechaString = fecha.getFullYear() +"-"+ Number(fecha.getMonth()+1)+  "-" + ((dia<10) ? ("0"+dia) :  dia);
  // let fechaString = ((dia<10) ? ("0"+dia) :  dia) + "/" + Number(fecha.getMonth()+1) + "/" +  fecha.getFullYear();
  const fechaString = ((dia < 10) ? ('0' + dia) :  dia) + '/' + ('0' + Number(fecha.getMonth() + 1)).slice(-2) + '/' +  fecha.getFullYear();

  // let horaString2 = fecha.getHours() + ":" + fecha.getMinutes();
  const horaString2 = ('0' + fecha.getHours()).slice(-2) + ':' + ('0' + fecha.getMinutes()).slice(-2);


  // let horaString = horaString2 + ":" + fecha.getSeconds();
  const horaString = horaString2 + ':' + ('0' + fecha.getSeconds()).slice(-2);


  return [fechaString, horaString, horaString2];
}

export function GetDateTimeString(fechaParam: string) {
  const fecha = new Date(fechaParam);
  const dia = fecha.getDate();
  const diaString = ((dia < 10) ? ('0' + dia) :  dia) ;
  const mes = Number(fecha.getMonth()) + 1;
  const mesString = (mes < 10) ? ('0' + String(mes)) : String(mes);
  const fechaString = diaString + '/' + mesString + '/' +  fecha.getFullYear() + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();

  return fechaString;
}

export function GetIdLS() {
  const fecha = new Date();
  const dia = fecha.getDate();
  const diaString = ((dia < 10) ? ('0' + dia) :  dia) ;
  const mes = Number(fecha.getMonth()) + 1;
  const mesString = (mes < 10) ? ('0' + String(mes)) : String(mes);

  const id = diaString + mesString +  fecha.getFullYear() + fecha.getHours() + fecha.getMinutes() + fecha.getSeconds() + fecha.getMilliseconds();

  return id;
}

export function ConvertStrDateToFormatBD(strFecha: string) {

  // se espera strFecha = "yyyy-mm-dd"

  // console.log("==========strFecha");
  // console.log(strFecha);

  let strReturn = '';

  if (strFecha != null) {
    strReturn = strFecha.substring(8) + '/' + strFecha.substring(5, 7)  + '/' +  strFecha.substring(0, 4)   + DscHoraDefault; // " 00:00:01";

  }
  // console.log("==========strReturn");
  // console.log(strReturn);
  // let fecha = fechaParam.toString();

  return strReturn;
}

export function ageFromDateOfBirth(dateOfBirth: Date) {

  return moment().diff(dateOfBirth, 'years');

}

export function isEmptyList(lista) {

  let vReturn = false;

  if (lista == null || !lista) {

    vReturn = true;

  } else if (lista.length == 0) {

    vReturn = true;

  }

  return vReturn;

}

export function isNotEmptyList(lista) {


  let vReturn = true;

  if (lista == null) {

    vReturn = false;

  } else if (lista.length == 0) {

    vReturn = false;

  }

  return vReturn;

  // return !this.isEmptyList(lista);

}



export function ConvertDateTimeToStr3(fechaParam: string) {

  let dscReturn = '';

  if (fechaParam != null) {

    dscReturn = fechaParam.substring(0, 4) + '-' + fechaParam.substring(4, 6)  + '-' + fechaParam.substring(6, 8);

  }

  return dscReturn;
}

export function ConvertDateTimeToStr4(fechaParam: string) {

  let dscReturn = '';

  if (fechaParam != null) {

    dscReturn = fechaParam.substring(6, 8) + '/' + fechaParam.substring(4, 6) + '/' + fechaParam.substring(0, 4)  + DscHoraDefault;

  }

  return dscReturn;
}



export function ConvertDateTimeToStr(fechaParam: Date) {

  // let fecha = fechaParam.toString();
  let fecha = '';
  let dscReturn = '';

  if (fechaParam != null) {

    fecha = fechaParam.toString();

    dscReturn = fecha.substring(0, 4) + '-' + fecha.substring(5, 7)  + '-' + fecha.substring(8, 10);

  }

  return dscReturn;
}

export function ConvertDateTimeToStr2(fechaParam: Date) {

  // let fecha = fechaParam.toString();
  let fecha = '';
  let dscReturn = '';

  if (fechaParam != null) {

    fecha = fechaParam.toString();

    dscReturn = fecha.substring(0, 4) + '-' + fecha.substring(5, 7)  + '-' + fecha.substring(8, 10) + ' ' + fecha.substring(11);



  }

  return dscReturn;
}
/**
 * GSOLIS
 */
export function ConvertDateTimeToStrForBD(fechaParam: Date, flgAgregaHora: boolean) {

  // let fecha = fechaParam.toString();
  const fecha = '';
  let dscReturn = '';

  if (fechaParam != null) {

    const dd = String(fechaParam.getDate()).padStart(2, '0');
    const mm = String(fechaParam.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = fechaParam.getFullYear();

    // fecha = fechaParam.toString();

    dscReturn = dd  + '/' + mm + '/' + yyyy; // fecha.substring(8,10) + "/" +  fecha.substring(5,7)  + "/" +fecha.substring(0,4) + (flgAgregaHora ? DscHoraDefault : "");//" 00:00:01";
  }

  return dscReturn;
}
 //
export function ConvertStringDateStr(fechaParam: string, numCaso: number) {

  let fecha = '';
  let vSeparador = '';


  if (fechaParam == null) {return; }

  switch (numCaso ) {
    case 1:

      vSeparador = '-';

      fecha = fechaParam.substring(6, 10) + vSeparador + fechaParam.substring(3, 5)  + vSeparador + fechaParam.substring(0, 2);

      break;

    case 2:

      vSeparador = '/';

      fecha = fechaParam.substring(8, 10) + vSeparador + fechaParam.substring(5, 7)  + vSeparador + fechaParam.substring(0, 4);

      break;

    default:
      break;
  }

  return fecha;
}




export function RecupPartesDocExp(strNumDocExp: string, idCaso: number) {

  let strReturn = '';

  if (strNumDocExp != null) {

    switch (idCaso) {
      case 1:

        strReturn = strNumDocExp.substring(0, strNumDocExp.indexOf('-'));

        break;

      case 2:

        strReturn = strNumDocExp.substring(strNumDocExp.indexOf('-') + 1, strNumDocExp.lastIndexOf('-'));

        break;

      case 3:

        strReturn = strNumDocExp.substring(strNumDocExp.lastIndexOf('-') + 1);

        break;
    }


  }

  return strReturn;

}

export function RecupPartesFchInicio(strFecha: string, idCaso: number) {

  let strReturn = '';

  if (strFecha != null) {

    switch (idCaso) {
      case 1:

        strReturn = strFecha.substring(11); // HORA

        break;

      case 2:

        strReturn = strFecha.substring(0, 10); // FECHA

        break;

      case 3:

        strReturn = strFecha.substr(11, 5); // hora sin seg

        break;

    }

  }

  return strReturn;

}

// export function _cargarTableMaterial(){


//   setTimeout(() => {

//     this.dataSource = new MatTableDataSource(this.instanciaList);

//     if(this.paginator != null){this.paginator._intl.itemsPerPageLabel = DscTituloPaginator}; //this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

//     this.dataSource.paginator = this.paginator;
//     this.dataSource.sort = this.sort;

//   }, 1);


// }

export class MfuncErrorVal {

  iconError = faTimesCircle;

  LeerErrorValidator(index: number, errorValidator: ErrorValidator[]) {

    let lbFlgReturn = false;
    let vElement = null;

    /* console.log(index);
    console.log(errorValidator); */
    if (errorValidator.length > 0) {

      vElement = errorValidator[index];

      if (vElement != null) {

        lbFlgReturn = vElement.flgInvalid;

      }

    }

    return lbFlgReturn;
  }

  AgregarErrorValidator(flgInvalid: boolean, dscMensaje: string, errorValidator: ErrorValidator[], flgReset: boolean) {

    // console.log("==========en la funcion 1");

    if (flgReset) {errorValidator = []; }

    const index = errorValidator.length;

    // console.log("==========en la funcion 13");

    // errorValidator[index] = new ErrorValidator();

    // errorValidator[index].flgInvalid = flgInvalid;
    // errorValidator[index].dscMensaje = (flgInvalid ? dscMensaje : "");

    errorValidator = this.GenerarErrorValidator(flgInvalid, dscMensaje, errorValidator, index);

    // console.log("==========en la funcion 12");

    return errorValidator;
  }

  AgregarErrorValIndex(flgInvalid: boolean, dscMensaje: string, errorValidator: ErrorValidator[], index: number) {

    if (index == 0) {errorValidator = []; }

    errorValidator = this.GenerarErrorValidator(flgInvalid, dscMensaje, errorValidator, index);



    return errorValidator;
  }

  GenerarErrorValidator(flgInvalid: boolean, dscMensaje: string, errorValidator: ErrorValidator[], index: number) {

    // console.log("==========0ErrorValidator");
    // console.log(errorValidator);
    // console.log(index);

    errorValidator[index] = new ErrorValidator();

    // console.log("==========111ErrorValidator");
    // console.log(errorValidator[index]);

    errorValidator[index].flgInvalid = flgInvalid;
    errorValidator[index].dscMensaje = (flgInvalid ? dscMensaje : '');

    // console.log("==========SALIOOOOOOO");

    return errorValidator;
  }





  RevisarErrorValidator(errorValidator: ErrorValidator[]) {

    // var vFlgError = false;

    // console.log("==============Revisar error");
    // console.log(errorValidator);

    // //this.errorValidator

    // errorValidator.forEach(element => {

    //   console.log("==============element");
    //   console.log(element);

    //   if(element.flgInvalid)
    //   {

    //     vFlgError = true;

    //     //break;

    //   }

    //   console.log("111111111111111111111==============element");
    //   console.log(element);

    // });

    // return vFlgError;

    return (errorValidator.filter(x => x.flgInvalid).length > 0 ? true : false); // SI HAY ERRORES ES TRUE
  }

  // this.mFuncErrorVal.AgregarErrorValidator

}

export function resolvedCaptcha(captchaResponse: string) {

  // console.log(`Resolved captcha with response: ${captchaResponse}`);

  return captchaResponse.length > 0 ? true : false;

}

export function recupDscTipoInstancia(codigo: string) {

  return codigo == 'OCI' ? 'OCI' : 'Entidad';

}

// export function matrizCamposFur(fur:Fur)
// {

//   var propNames = Object.getOwnPropertyNames(fur);

//   propNames.forEach(element => {

//     if(element.indexOf("fur"))
//     {

//       vGeneralItem = new General();

//       vGeneralItem.dscCampo1 = element;
//       vGeneralItem.dscCampo2 = this.fur[element];

//       vGeneral.push(vGeneralItem);

//       //console.log(this.fur["denunciante"][element]);

//     }

//   });

//     return
// }

export function isNumber(value: string | number): boolean {
   return ((value != null) &&
           (value !== '') &&
           !isNaN(Number(value.toString())));
}

export function recupToolTipCar(valor: string) {

    let strReturn: string = null;

    strReturn = StrDscToolTipText;

    if (valor) {

      const cant: number = valor.length;
      const cantRestante: number = IntCantTotalCar - cant;

      if (cantRestante <= 0) {

        strReturn = StrDscToolTipText;

      } else {

        strReturn = 'Cantidad de caracteres restantes ' + cantRestante.toString();

      }



    }

    return strReturn;

  }

export function recupContenidoEmail(mensaje: string) {

    return  HtmlCabeceraEmail + mensaje + HtmlPieEmail;

  }




export function CargarDatosPlantilla(listCatalogo: Catalogo[]) {

  const vListPdDatos: PDDatos[] = [];
  let vPdDatos: PDDatos = new PDDatos();

  // listCatalogo = listCatalogo.sort(x=>x.ncatalogoId);

  listCatalogo.sort(function(a, b) {

    if (a.ncatalogoId > b.ncatalogoId) {
      return 1;
    }

    if (a.ncatalogoId < b.ncatalogoId) {
      return -1;
    }
    // a must be equal to b
    return 0;
  });

  // console.log("===========listCatalogo");
  // console.log(listCatalogo);

  listCatalogo.forEach((element, index) => {

    index = index + 1;

    if ((index % 2)) {

      vPdDatos.nombre = element.ccatalogoDsc;

    } else {

      vPdDatos.campo = element.ccatalogoDsc;

      vListPdDatos.push(vPdDatos);

      vPdDatos = new PDDatos();

    }

  });

  return vListPdDatos;

}

export function letraCapital(str: string) {

  if (!str) {return ''; }

  const pieces = str.toString().split(' ');

  for ( let i = 0; i < pieces.length; i++ ) {
      const j = pieces[i].charAt(0).toUpperCase();
      pieces[i] = j + pieces[i].substr(1).toLowerCase();
  }
  return pieces.join(' ');
}


export function limpiarTexto(str: string) {


  const list = str.split('\n');

  for (let i = 0; i < list.length; i++) {

    list[i] = list[i].replace(/^\s*[o\W]\s+/g, '');
    list[i] = list[i].replace(/[“]/g, '"');
    list[i] = list[i].replace(/[”]/g, '"');
    list[i] = list[i].replace(/[…]/g, '...');
    list[i] = list[i].replace(/[¿]/g, '-');

  }

  return list.join('\n');

}

export function modificarTamañoModal(configuracionGlobal: MatDialogConfig) {

  configuracionGlobal.width =  'calc(100% - 30px)';
  configuracionGlobal.maxWidth =  '100%';

  return configuracionGlobal;

}



export function RecupObjDatosPlant(obj: any, pdDatos: PDDatos[]) {

  const vGeneral: General[] = [];
  let vGeneralFinal: General[] = [];

  let vGeneralItem: General = null;
  let propNames = null; /// = Object.getOwnPropertyNames(this.fur);
  let propNames_1 = null;
  let vItemValor: General = null;
  let propNames_2 = null;
  let vStrValor = '';

  propNames = Object.getOwnPropertyNames(obj);

  // console.log("=============propNames");

  propNames.forEach(

          function(propName) {

              // console.log('name: ' + propName );
              // console.log('value: ' + vFur[propName] );

              vGeneralItem = new General();

              vGeneralItem.dscCampo1 = propName;
              vGeneralItem.dscCampo2 = obj[propName];

              vGeneral.push(vGeneralItem);

              if (obj[propName] != null) {

                propNames_1 = Object.getOwnPropertyNames(obj[propName]);

                // console.log("XXXX1");
                // console.log(propNames_1);

                if (propNames_1.length > 0) {

                  propNames_1.forEach(

                    function(propName1) {

                      vGeneralItem = new General();

                      vGeneralItem.dscCampo1 = propName1;
                      vGeneralItem.dscCampo2 = obj[propName][propName1];

                      vGeneral.push(vGeneralItem);

                      if (obj[propName][propName1] != null) {

                        propNames_2 = Object.getOwnPropertyNames(obj[propName][propName1]);

                        if (propNames_2.length > 0) {

                          propNames_2.forEach(

                            function(propName2) {

                              vGeneralItem = new General();

                              vGeneralItem.dscCampo1 = propName2;
                              vGeneralItem.dscCampo2 = obj[propName][propName1][propName2];

                              vGeneral.push(vGeneralItem);

                            });

                        }

                      }

                    });

                }


              }

          }

        );

        // console.log("============vGeneral");
        // console.log(vGeneral);

  vGeneralFinal = vGeneral.filter(x => !isNumber(x.dscCampo1) && x.dscCampo1 != 'length');

      // console.log("=============pdDatos");
      // console.log(pdDatos);

  pdDatos.forEach(element => {

        vStrValor = '';

        vItemValor = vGeneralFinal.find(x => x.dscCampo1 == element.campo);

        if (vItemValor != null) {

          vStrValor = vItemValor.dscCampo2;

        }


        vStrValor = (vStrValor == null ? '' : vStrValor);

        element.valor = letraCapital(vStrValor);

        // element.valor = vStrValor;

      });

  return pdDatos;


}


// export function depurarListTipDenAnonimo(listTipDenunciante : TipoDenunciante[]) {

//   var vListDenunciante = listTipDenunciante.filter(x => x.ntipdenuncianteId = NumIdTipDenAnonimo);;

//   listTipDenunciante.splice()

//   for (let index = 0; index < vListDenunciante.length; index++)
//   {

//     if(vListDenunciante[index].ntipdenuncianteId = )
//     {

//       listTipDenunciante.splice(index,1);

//     }

//   }

//   console.log("==============listTipDenunciante");
//   console.log(listTipDenunciante);

//   return listTipDenunciante;

// }




/*Icons */
export const iconEliminar = faTrash;
export const iconAgregar = faPlus;
export const iconBuscar = faSearch;
export const iconVer = faEye;
export const iconEditar = faEdit;
export const iconDescargar = faDownload;
export const iconPdf = faFilePdf;
export const iconBook = faBook;
export const iconComment = faComment;
export const iconLock = faLock;
export const iconRss = faRss;

export const ngClassAceptarModal = 'btn-sm btn-primary form-control form-control-sm';
export const ngClassSalirModal = 'btn-sm btn-light-modal form-control form-control-sm';
export const ngClassColorBtn3 = 'btn-sm btn-3-modal form-control form-control-sm';
export const dscEtiquetaBtnAcepModal = 'Guardar';
export const dscEtiquetaBtnSalirModal = 'Regresar';



export const strDscMsjPrgEliminar = '¿Está seguro que desea eliminar?';


export function HttpHeaderToken() {

  return {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      //Authorization:  localStorage.getItem('tokenfv')
    })
  };
}



export function cambiarRouter(router: Router, numCaso: number) {

    switch (numCaso) {
      case 1:

        router.navigate(['/denunciar/']);

        break;

      case 2:

        router.navigate(['/denunciar/']);

        break;

      case 3:

        router.navigate(['/denunciar/']);

        break;

      case 4:

        router.navigate(['/registroexitoso/']);

        break;

      case 5:

        router.navigate(['/denunciar/']);

        break;

      case 6:

        router.navigate(['/denunciar/']);

        break;


      default:
        break;
    }
}


export function cargarDatosInstanciaBPM(fur: Fur, strDscInfoCompl?: string, strCodUniOrg?: string, strDscNomEntidad?: string) {

  const requestNewInstanceGC: RequestNewInstanceGC = new RequestNewInstanceGC();

  if (isEmpty(strCodUniOrg) ) {

    strCodUniOrg = fur.entidad.cuniCodigo;

  }

  if (isEmpty(strDscNomEntidad) ) {

    strDscNomEntidad = fur.entidad.centNombre;

  }

  requestNewInstanceGC.intIdFurHI = fur.nfurId;
  requestNewInstanceGC.intIdFurHICanal = fur.nfurIdcanal;
  requestNewInstanceGC.strCodFurHI = fur.cfurCodigo;
  requestNewInstanceGC.numFormulario = fur.cfurCodborrador;
  requestNewInstanceGC.canal = 'Formulario Virtual';
  requestNewInstanceGC.unidad = strCodUniOrg;

  if (!isEmpty(strDscInfoCompl) ) {

    requestNewInstanceGC.tipoDivision = strDscInfoCompl;

  }


  const removeAccents = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  requestNewInstanceGC.entidadInvolucrada = removeAccents(strDscNomEntidad);

  requestNewInstanceGC.tipoDenunciante = (fur.denunciante.cdenuncianteFlganonimo == 'SI' ? 'Anonimo' : 'Persona Natural') ;

  return requestNewInstanceGC;

}



